import { useEffect } from 'react';

/**
 * Swap the document favicon at runtime. If `url` is undefined we leave the
 * baseline `/favicon.svg` in place. Also rewrites the document title to use
 * the brand name.
 */
export function useFavicon(url: string | undefined, brandName: string) {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (link) {
      link.href = url || '/favicon.svg';
    }
    document.title = `${brandName} — ${brandName === 'SFP' ? 'Shulkin Family Partners' : 'home base'}`;
  }, [url, brandName]);
}
